import React from "react"

import ApplicationComplete from "@/components/application/ApplicationComplete"
import AppLayout from "@/components/layout/AppLayout"

const ApplicationCompletePage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-6">
        <ApplicationComplete />
      </div>
    </AppLayout>
  )
}

export default ApplicationCompletePage
